import React, { useEffect, useState } from "react";
import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import SnagLogoWithWhiteName from "../assest/whiteNameLogo.svg";
import UserShapeIconFilled from "../assest/Subtracts.svg";


import VehicleIcon from '../assest/gis_car.svg'
import SpotGiverIcon from '../assest/line-md_brake-parking-filled.svg'
import SpotSeekerIcon from '../assest/mdi_car-child-seat.svg'
import FeedBackIcon from '../assest/fluent_person-feedback-24-filled.svg'
import TicketIcon from '../assest/solar_ticket-bold.svg'
import PassIcon from '../assest/iconamoon_lock-off-fill.svg'
// import LogoutIcon from ".
import "./Main.css";
import LogoutIcon from '@mui/icons-material/Logout';
import LocalTaxiIcon from '@mui/icons-material/LocalTaxi';
import { logout } from "../../redux/userSlice";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
const Sidebar = ({ isSidebarOpen, toggleSidebar, isMobileView }) => {
  const [activeTab, setActiveTab] = useState("users");
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch=useDispatch();
  
  useEffect(() => {
    const currentPath = location.pathname;
    const matchingItem = menuItems.find((item) => currentPath.includes(item.key));
    if (matchingItem) {
      setActiveTab(matchingItem.key);
    } else if (currentPath.includes("change-password")) {
      setActiveTab("change-password");
    } else {
      setActiveTab("users");
    }
  }, [location]);


  const handleRoutes = (tab, path) => {
    setActiveTab(tab);
    navigate(path);
  };


  const handleLogout = () => {
    const isConfirmed = window.confirm("Are you sure you want to logout?");
    if (!isConfirmed) {
      return;
    } else {
      dispatch(logout());
      toast.success("Admin Logout");
    }
  };

  const handleChangePassword = () => {
    setActiveTab("change-password");
    navigate("/change-password");
  };

  const menuItems = [
    { name: "Users", key: "users", icon: UserShapeIconFilled, route: "/users" },
    { name: "Vehicles", key: "vehicles", icon: VehicleIcon, route: "/vehicles" },
    { name: "Spot Givers", key: "spot-givers", icon: SpotGiverIcon, route: "/spot-givers" },
    { name: "Spot Seekers", key: "spot-seekers", icon: SpotSeekerIcon, route: "/spot-seekers" },
    // { name: "Snags", key: "snags", icon: UserShapeIconFilled, route: "/snags" },
    { name: "Feedbacks", key: "feedbacks", icon: FeedBackIcon, route: "/feedbacks" },
    { name: "Support Tickets", key: "support-tickets", icon: TicketIcon, route: "/support-tickets" },
   
  ];
  

  return (
    <Drawer
      sx={{
        borderRadius: "0px 24px 24px 0px !important",
        "& .MuiPaper-root": {
          borderRadius: "0px 24px 24px 0px",
          border: "none",
          height: "100vh",
          backgroundColor: "none",
        },
      }}
      anchor="left"
      open={isSidebarOpen || !isMobileView}
      onClose={toggleSidebar}
      variant={isMobileView ? "temporary" : "persistent"}
    >
      <div
        style={{
          width: "244px",
          height: "100vh",
          borderRadius: "0px 24px 24px 0px",
          background: "linear-gradient(90deg, #4449FE 17.88%, #13A6F2 100%)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          paddingLeft: "10px",
        }}
      >
        <div style={{ textAlign: "center", marginTop: "20px" ,marginLeft: "50px",marginRight:'70px'}}>
          <img src={SnagLogoWithWhiteName} alt="Chef Logo" style={{ width: "120px" }} />
        </div>

<List sx={{ marginTop: "20px" }}>
  {menuItems.map((item) => (
    <ListItem
      key={item.key}
      sx={{
        maxWidth: "230px",
        height: "60px",
        cursor: "pointer",
        borderRadius: "18px",
        fontFamily: "Inter, sans-serif",
        opacity: activeTab === item.key ? "1" : "0.6",
        color: activeTab === item.key ? "white" : "#B0B0B0",
        backgroundColor:
          activeTab === item.key
            ? "rgba(255, 255, 255, 0.3)"
            : "transparent",
      }}
      onClick={() => handleRoutes(item.key, item.route)}
    >
      <ListItemIcon sx={{ minWidth: "35px" }}>
        <img src={item.icon} alt={`${item.name} Icon`}  style={{width:'30px'}}/>
      </ListItemIcon>
      <ListItemText
        primary={item.name}
        sx={{  fontFamily: "Inter, sans-serif", color: "inherit" }}
      />
    </ListItem>
  ))}
</List>


        <Divider sx={{ marginY: "5px", backgroundColor: "rgba(255, 255, 255, 0.5)" }} />


        <ListItem
          sx={{
            maxWidth: "230px",
            height: "60px",
            cursor: "pointer",
            borderRadius: "18px",
            color: "#B0B0B0",
            display:'flex',
            justifyContent:'center'
            ,alignItems:"center",
            "&:hover": {
              backgroundColor: "rgba(255, 255, 255, 0.3)",
            },
            opacity: activeTab === "change-password" ? "1" : "0.6",
            color: activeTab === "change-password" ? "white" : "#B0B0B0",
            backgroundColor:
              activeTab === "change-password"
                ? "rgba(255, 255, 255, 0.3)"
                : "transparent",
        
          }}
          onClick={handleChangePassword}
        >
          <ListItemIcon sx={{ minWidth: "35px" }}>
            <img src={PassIcon} alt="changePass Icon" style={{width:'28px'}}/>
            {/* <LogoutIcon  sx={{color:'white'}}/> */}
          </ListItemIcon>
          <ListItemText
            primary="Change Password"
            sx={{  fontFamily: "Inter, sans-serif", color: "inherit" }}
          />
        </ListItem>


        <ListItem
          sx={{
            maxWidth: "230px",
            height: "60px",
            cursor: "pointer",
            borderRadius: "18px",
            marginTop:'10px',
            color: "#B0B0B0",
            "&:hover": {
              backgroundColor: "rgba(255, 255, 255, 0.3)",
            },
          }}
          onClick={handleLogout}
        >
          <ListItemIcon sx={{ minWidth: "35px" }}>
            {/* <img sr c={LogoutIcon} alt="Logout Icon" /> */}
            <LogoutIcon  sx={{color:'white',marginLeft:'7px'}}/>
          </ListItemIcon>
          <ListItemText
            primary="Logout"
            sx={{  fontFamily: "Inter, sans-serif", color: "inherit" }}
          />
        </ListItem>
      </div>
    </Drawer>
  );
};

export default Sidebar;
